import StafetHeader from '../StafetHeader/StafetHeader.vue'
import StafetAddDeltager from '../StafetAddDeltager/StafetAddDeltager.vue'
import StafetPayment from '../StafetPayment/StafetPayment.vue'
import StafetActions from '../StafetActions/StafetActions.vue'
import { scrollToFirstError } from '../../foundation/js/inputValidators/scrollToFirstError'
import { ref, computed  } from 'vue'
import { useStore } from 'vuex'
import updateBasket from './methods/updateBasket'

export default {
    name: 'StafetAddMoreDeltagerFlow',
    components: {
        StafetHeader,
        StafetAddDeltager,
        StafetPayment,
        StafetActions
    },
    props: {
        stafetId: {
            type: String,
            required: true
        },
        holdkode: {
            type: String,
            required: false
        },
        userData: {
            type: Object,
            required: false
        },
        adultPrice: {
            type: Number,
            required: true
        },
        childPrice: {
            type: Number,
            required: true
        }
    },
    setup(props) {
        const store = useStore()
        const displayInputError = ref(false)
        const participants = ref({ adults: [], children: [] })

        const labels = computed(() => {
            return store.state.labels.collections['SFLAddDeltagereLabels']
        })

        const basket = computed(() => {
            return store.state.stafet.basket
        })

        const basketTotalPrice = computed(() => {
            return store.state.stafet.basketTotalPrice
        })


        const updateAddParticipants = (data) => {
            participants.value = data
            updateBasket(
                participants.value,
                labels.value,
                store,
                props.adultPrice,
                props.childPrice
            )
            updateVuexStore()
        }

        const updateVuexStore = () => {
            const deltagere = {
                name: 'deltagere',
                isValid: participants.value.isValid,
                value: participants.value.adults
            }
            const childDeltagere = {
                name: 'childDeltagere',
                isValid: participants.value.isValid,
                value: participants.value.children
            }
            store.dispatch('stafet/userInputs', {
                inputs: [deltagere, childDeltagere]
            })
        }

    

        const goToPayment = () => {
            if (participants.value && participants.value.isValid === true) {
                displayInputError.value = false
                store.dispatch('stafet/addDeltagereSubmit', {
                    stafetId: props.stafetId,
                    teamId: props.holdkode,
                    userData: props.userData
                })
            } else {
                displayInputError.value = true
                scrollToFirstError()
            }
        }

        return {
            displayInputError,
            labels,
            participants,
            basket,
            basketTotalPrice,
            updateAddParticipants,
            goToPayment
        }
    }
}
